export const CONTACT_METHOD_SMS = 'sms';
export const LEGAL_BASIS_CONSENT = 'consent';
export const ACCEPTANCE_METHOD_WEB_FORM = 'web_form';
export const CONSENT_TEXT = 'I would like to receive support and updates from ShipStation via SMS.';

export const PHONE_CAPTURE_SOURCE = {
  AUTO: 'auto',
  BANNER: 'banner',
  TODO: 'todo',
  FTU_WIZARD: 'ftu_wizard',
  SETTINGS: 'settings',
} as const;

export type PhoneCaptureSource = (typeof PHONE_CAPTURE_SOURCE)[keyof typeof PHONE_CAPTURE_SOURCE];
